// extracted by mini-css-extract-plugin
export var columnList = "_bk-0";